<style lang="stylus">
    .expand-context{
        position: absolute;
        >div{
            padding: 6px;
            background-color: var(--bg-color-tertiary);
            box-shadow: $box-shadow;
            border: 0.5px solid var(--border-color-box-4);
            border-radius: 8px;
            overflow: hidden;
        }
    }
    .menu-item{
    	.menu-shortcut{
            margin-left: 35px;
            color: #9E9E9E;
        }
    }
    .remember-box{
        .ivu-radio-wrapper{
            padding 0px 10px
            margin-right 0px
            border-radius: 6px;
            &:hover{
                background-color: var(--bg-color-menu-item-active);
            }
        }
    }
</style>

<i18n>
{
  "zh": {
    "bringFront": "置于顶层",
    "bringForward": "上移一层",
    "sendBack": "置于底层",
    "sendBackWard": "下移一层",
    "group": "组合",
    "unGroup": "取消组合",
    "left": "左对齐",
    "center": "水平居中",
    "right": "右对齐",
    "top": "顶端对齐",
    "middle": "垂直居中",
    "bottom": "底端对齐",
    "horizontal": "横向等距分布",
    "vertical": "纵向等距分布",
    "width": "等宽",
    "height": "等高",
    "width&height": "等大小",
    "angle": "等角度",
    "connector": "连接线",
    "text": "文本框",
    "shape": "形状",
    "img": "图片",
    "guideLine": "参考线",
    "showGrid": "显示网格",
    "snapGrid": "吸附网格",
    "gridSetting": "网格设置",
    "showGuides": "显示参考线",
    "snapGuides": "吸附参考线",
    "crossPoint0": "无",
    "crossPoint1": "弧线",
    "crossPoint2": "间隙",
    "crossPoint3": "正方形",
    "crossPoint4": "两面",
    "crossPoint5": "三面",
    "showMargins": "显示边界",
    "marginSetting": "边界设置",
    "insText": "插入文本",
    "insHyper": "插入超链接",
    "insAttach": "插入附件",
    "insNote": "插入注释",
    "insCom": "插入评论",
    "swimTitle": {
      "noShow": "不显示",
      "showTop": "显示顶部",
      "showLeft": "显示左侧"
    },
    "keepFormat": "保留文本源格式",
    "matchFormat": "匹配文本当前格式",
    "compare": "数据对比",
    "error": "异常识别",
    "summarize": "概括总结",
    "trend": "趋势预测",
    "org_analysis": "组织分析",
    "check": "组织诊断",
    "ganttTotal": "项目概述",
    "ganttProgress": "项目进展",
    "ganttRisk": "风险识别",
    "ganttShare": "项目经验分享",
    "flowPart": "流程图检测",
    "flowDesc": "流程图说明",
    "flowImprove": "流程图优化",
    "more": "更多"
  },
  "en": {
    "bringFront": "To front",
    "bringForward": "Forward",
    "sendBack": "To Back",
    "sendBackWard": "Backward",
    "group": "Group",
    "unGroup": "Ungroup",
    "left": "Left",
    "center": "Center",
    "right": "Right",
    "top": "Top",
    "middle": "Middle",
    "bottom": "Bottom",
    "horizontal": "Distribute Horizontally",
    "vertical": "Distribute Vertically",
    "width": "Width",
    "height": "Height",
    "width&height": "Size",
    "angle": "Angle",
    "connector": "Connector",
    "text": "Texts",
    "shape": "Shape",
    "img": "Image",
    "guideLine": "Guides",
    "showGrid": "Show Grid",
    "snapGrid": "Snap to Grid",
    "gridSetting": "Grid Settings",
    "showGuides": "Show Guides",
    "snapGuides": "Snap to Guides",
    "crossPoint0": "None",
    "crossPoint1": "Arc",
    "crossPoint2": "Gap",
    "crossPoint3": "Square",
    "crossPoint4": "Two Sides",
    "crossPoint5": "Three Sides",
    "showMargins": "Show Margins",
    "marginSetting": "Margin Settings",
    "insText": "Insert Text",
    "insAttach": "Insert Attachment",
    "insHyper": "Insert Hyperlink",
    "insNote": "Insert Note",
    "insCom": "Insert Comment",
    "swimTitle": {
      "noShow": "Do not Show",
      "showTop": "Show Top",
      "showLeft": "Show Left"
    },
    "keepFormat": "Keep source formatting",
    "matchFormat": "Match destination formatting",
    "compare": "Data Comparison",
    "error": "Anomaly Identification",
    "summarize": "Summary",
    "trend": "Trends Prediction",
    "org_analysis": "Organization Analysis",
    "check": "Organization Diagnosis",
    "ganttTotal": "Project Overview",
    "ganttProgress": "Project Progress",
    "ganttRisk": "Risk Identification",
    "ganttShare": "Lessons Learned",
    "flowPart": "Flowchart Detection",
    "flowDesc": "Flowchart Description",
    "flowImprove": "Flowchart Optimization",
    "more": "More"
  },
  "fr": {
    "bringFront": "Vers l'avant",
    "bringForward": "Avance",
    "sendBack": "Vers l'arrière",
    "sendBackWard": "Retour",
    "group": "Grouper",
    "unGroup": "Dissocier",
    "left": "Aligner à gauche",
    "center": "Centrer",
    "right": "Aligner à droite",
    "top": "Aligner en haut",
    "middle": "Aligner au milieu",
    "bottom": "Aligner en bas",
    "horizontal": "Distribuer horizontalement",
    "vertical": "Distribuer verticalement",
    "width": "Largeur",
    "height": "Hauteur",
    "width&height": "Largeur et hauteur",
    "angle": "Angle",
    "connector": "Connecteur",
    "text": "Tous les textes",
    "shape": "Forme",
    "img": "Image",
    "guideLine": "Repères",
    "showGrid": "Afficher le quadrillage",
    "snapGrid": "Aligner sur la grille",
    "gridSetting": "Paramètres de la grille",
    "showGuides": "Afficher les repères",
    "snapGuides": "Aligner sur les repères",
    "crossPoint0": "Aucun",
    "crossPoint1": "Arc",
    "crossPoint2": "Écart",
    "crossPoint3": "Carré",
    "crossPoint4": "Deux côtés",
    "crossPoint5": "Trois côtés",
    "showMargins": "Show Margins",
    "marginSetting": "Margin Settings",
    "insText": "Insérer du texte",
    "insHyper": "Insérer hyperlien",
    "insAttach": "Insérer pièce jointe",
    "insNote": "Insérer note",
    "insCom": "Insérer commentaire",
    "swimTitle": {
      "noShow": "Ne montre pas",
      "showTop": "Afficher le haut",
      "showLeft": "Afficher à gauche"
    },
    "keepFormat": "Conservez le formatage de la source",
    "matchFormat": "Faire correspondre le formatage de la destination",
    "compare": "Comparaison des données",
    "error": "Identification des anomalies",
    "summarize": "Résumé",
    "trend": "Prédiction des tendances",
    "org_analysis": "Analyse d'organisation",
    "check": "Diagnostic d'organisation",
    "ganttTotal": "Aperçu du projet",
    "ganttProgress": "Avancement du projet",
    "ganttRisk": "Identificación de riesgos",
    "ganttShare": "Leçons apprises",
    "flowPart": "Détection d'organigramme",
    "flowDesc": "Description d'organigramme",
    "flowImprove": "Optimisation d'organigramme",
    "more": "Plus"
  },
  "de": {
    "bringFront": "Nach vorne",
    "bringForward": "Vor",
    "sendBack": "Nach hinten",
    "sendBackWard": "Zurück",
    "group": "Gruppieren",
    "unGroup": "Gruppierung aufheben",
    "left": "Linksbündig",
    "center": "Horizontal zentrieren",
    "right": "Rechtsbündig",
    "top": "Oben ausrichten",
    "middle": "Vertikal zentrieren",
    "bottom": "Unten ausrichten",
    "horizontal": "Horizontal ",
    "vertical": "Vertikal ",
    "width": "Breite",
    "height": "Größe",
    "width&height": "Breite & Größe",
    "angle": "Winkel",
    "connector": "Verbinder",
    "text": "Alle Texte",
    "shape": "Form",
    "img": "Bild ",
    "guideLine": "Führungslinien",
    "showGrid": "Gitternetzlinien anzeigen",
    "snapGrid": "Am Raster ausrichten",
    "gridSetting": "Gitternetzeigenschaft",
    "showGuides": "Führungslinien anzeigen",
    "snapGuides": "An Führungslinien ausrichten",
    "crossPoint0": "Keiner",
    "crossPoint1": "Bogen",
    "crossPoint2": "Lücke",
    "crossPoint3": "Quadrat",
    "crossPoint4": "Zwei Seiten",
    "crossPoint5": "Drei Seiten",
    "showMargins": "Margen anzeigen",
    "marginSetting": "Margen festlegen",
    "insText": "Text einfügen",
    "insHyper": "Hyperlink einfügen",
    "insAttach": "Anlage einfügen",
    "insNote": "Notiz einfügen",
    "insCom": "Kommentar einfügen",
    "swimTitle": {
      "noShow": "Zeig nicht",
      "showTop": "Oben anzeigen",
      "showLeft": "Links anzeigen"
    },
    "keepFormat": "Formatierung der Quelle beibehalten",
    "matchFormat": "Zielformatierung anpassen",
    "compare": "Datenvergleich",
    "error": "Erkennung von Anomalien",
    "summarize": "Zusammenfassung",
    "trend": "Trendvorhersage",
    "org_analysis": "Organisationsanalyse",
    "check": "Organisationsdiagnose",
    "ganttTotal": "Projektübersicht",
    "ganttProgress": "Projektfortschritt",
    "ganttRisk": "Risikoermittlung",
    "ganttShare": "Gesammelte Erfahrungen",
    "flowPart": "Flussdiagramm-Erkennung",
    "flowDesc": "Flussdiagramm-Beschreibung",
    "flowImprove": "Flussdiagrammen-Optimierung",
    "more": "Mehr"
  },
  "jp": {
    "bringFront": "正面",
    "bringForward": "前方",
    "sendBack": "背面",
    "sendBackWard": "後方",
    "group": "グループ化",
    "unGroup": "グループ化解除",
    "left": "左揃え",
    "center": "左右中央揃え",
    "right": "右揃え",
    "top": "上揃え",
    "middle": "上下中央揃え",
    "bottom": "下揃え",
    "horizontal": "水平",
    "vertical": "垂直",
    "width": "幅",
    "height": "高さ",
    "width&height": "幅と高さ",
    "angle": "角度",
    "connector": "コネクター",
    "text": "全てのテキスト",
    "shape": "形状",
    "img": "画像",
    "guideLine": "ガイドライン",
    "showGrid": "グリッドを表示",
    "snapGrid": "グリッドにスナップ",
    "gridSetting": "グリッド設定",
    "showGuides": "ガイドラインを表示",
    "snapGuides": "ガイドラインにスナップ",
    "crossPoint0": "なし",
    "crossPoint1": "弧線",
    "crossPoint2": "ギャップ",
    "crossPoint3": "正方形",
    "crossPoint4": "三角形",
    "crossPoint5": "台形",
    "showMargins": "余白を表示",
    "marginSetting": "余白設定",
    "insText": "テキストを挿入",
    "insHyper": "ハイパーリンクを挿入",
    "insAttach": "添付を挿入",
    "insNote": "注釈を挿入",
    "insCom": "コメントを挿入",
    "swimTitle": {
      "noShow": "表示しない",
      "showTop": "上部に表示",
      "showLeft": "左に表示"
    },
    "keepFormat": "ソースフォーマットを維持",
    "matchFormat": "目標フォーマットに一致",
    "compare": "データ比較",
    "error": "異常の特定",
    "summarize": "まとめ",
    "trend": "トレンド予測",
    "org_analysis": "組織分析",
    "check": "組織診断",
    "ganttTotal": "プロジェクトの概要",
    "ganttProgress": "プロジェクトの進行状況",
    "ganttRisk": "リスクの特定",
    "ganttShare": "项目经得られた経験验分享",
    "flowPart": "フローチャートの検出",
    "flowDesc": "フローチャートの説明",
    "flowImprove": "フローチャートの最適化",
    "more": "その他"
  },
  "es": {
    "bringFront": "Hacia delante",
    "bringForward": "Avanzar",
    "sendBack": "Hacia atrás",
    "sendBackWard": "Retroceder",
    "group": "Grupo",
    "unGroup": "Desagrupar",
    "left": "Izquierda",
    "center": "Centro",
    "right": "Derecha",
    "top": "Arriba",
    "middle": "Medio",
    "bottom": "Abajo",
    "horizontal": "Distribuir horizontalmente",
    "vertical": "Distribuir verticalmente",
    "width": "Ancho",
    "height": "Altura",
    "width&height": "Tamaño",
    "angle": "Ángulo",
    "connector": "Conector",
    "text": "Todos los Textos",
    "shape": "Forma",
    "img": "Imagen",
    "guideLine": "Guías",
    "showGrid": "Mostrar cuadrícula",
    "snapGrid": "Ajustar cuadrícula",
    "gridSetting": "Ajustes de cuadrícula",
    "showGuides": "Mostrar Guías",
    "snapGuides": "Ajustar a las Guías",
    "crossPoint0": "Ninguno",
    "crossPoint1": "Arco",
    "crossPoint2": "Brecha",
    "crossPoint3": "Cuadrado",
    "crossPoint4": "Dos Lados",
    "crossPoint5": "Tres lados",
    "showMargins": "Mostrar márgenes",
    "marginSetting": "Ajustes del margen",
    "insText": "Insertar Texto",
    "insHyper": "Insertar el hipervínculo",
    "insAttach": "Insertar adjunto",
    "insNote": "Inserte la nota",
    "insCom": "Insertar Comentario",
    "swimTitle": {
      "noShow": "No mostrar",
      "showTop": "Mostrar la parte superior",
      "showLeft": "Mostrar a la izquierda"
    },
    "keepFormat": "Mantener el formato de origen",
    "matchFormat": "Coincidir con el formato de destino",
    "compare": "Comparación de datos",
    "error": "Identificación de anomalías",
    "summarize": "Resumen",
    "trend": "Predicción de tendencias",
    "org_analysis": "Análisis de organización",
    "check": "Diagnóstico de organización",
    "ganttTotal": "Descripción general del proyecto",
    "ganttProgress": "Progreso del proyecto",
    "ganttRisk": "Identificación de riesgos",
    "ganttShare": "Lecciones aprendidas",
    "flowPart": "Detección de diagrama de flujo",
    "flowDesc": "Descripción de diagrama de flujo",
    "flowImprove": "Optimización de diagrama de flujo",
    "more": "Más"
  },
  "pt": {
    "bringFront": "Para frente",
    "bringForward": "Avançar",
    "sendBack": "Para trás",
    "sendBackWard": "Retroceder",
    "group": "Agrupar",
    "unGroup": "Desagrupar",
    "left": "Esquerda",
    "center": "Centro",
    "right": "Direita",
    "top": "Em cima",
    "middle": "Meio",
    "bottom": "Em baixo",
    "horizontal": "Distribuir Horizontalmente",
    "vertical": "Distribuir Verticalmente",
    "width": "Largura",
    "height": "Altura",
    "width&height": "Tamanho",
    "angle": "Ângulo",
    "connector": "Conector",
    "text": "Todos os textos",
    "shape": "Forma",
    "img": "Imagem",
    "guideLine": "Guias",
    "showGrid": "Mostrar Grelha",
    "snapGrid": "Encaixar para Grelha",
    "gridSetting": "Configurações de Grelha",
    "showGuides": "Mostrar Guias",
    "snapGuides": "Encaixar para Guias",
    "crossPoint0": "Nenhum",
    "crossPoint1": "Arco",
    "crossPoint2": "Intervalo",
    "crossPoint3": "Quadrado",
    "crossPoint4": "Dois Lados",
    "crossPoint5": "Três Lados",
    "showMargins": "Mostrar Limites",
    "marginSetting": "Configurações de Limite",
    "insText": "Inserir Texto",
    "insHyper": "Inserir Hiperligação",
    "insAttach": "Inserir Anexo",
    "insNote": "Inserir Nota",
    "insCom": "Inserir Comentário",
    "swimTitle": {
      "noShow": "Não mostre",
      "showTop": "Mostrar top",
      "showLeft": "Mostrar à esquerda"
    },
    "keepFormat": "Manter a formatação da fonte",
    "matchFormat": "Formatação de destino correspondente",
    "compare": "Comparação de dados",
    "error": "Identificação de anomalia",
    "summarize": "Resumo",
    "trend": "Previsão de tendências",
    "org_analysis": "Análise da organização",
    "check": "Diagnóstico da organização",
    "ganttTotal": "Visão geral do projeto",
    "ganttProgress": "Progresso do projeto",
    "ganttRisk": "Identificação de risco",
    "ganttShare": "Lições aprendidas",
    "flowPart": "Detecção de fluxograma",
    "flowDesc": "Descrição do fluxograma",
    "flowImprove": "Otimização de fluxograma",
    "more": "Mais"
  },
  "it": {
    "bringFront": "Porta avanti",
    "bringForward": "Avanti",
    "sendBack": "Porta indietro",
    "sendBackWard": "Indietro",
    "group": "Raggruppa",
    "unGroup": "Separa",
    "left": "Sinistra",
    "center": "Centro",
    "right": "Destra",
    "top": "In Alto",
    "middle": "Mezzo",
    "bottom": "In Basso",
    "horizontal": "Distribuisci Orizzontalmente",
    "vertical": "Distribuisci Verticalmente",
    "width": "Larghezza",
    "height": "Altezza",
    "width&height": "Dimensione",
    "angle": "Angolo",
    "connector": "Connettore",
    "text": "Tutti i Testi",
    "shape": "Forma",
    "img": "Immagine",
    "guideLine": "Guide",
    "showGrid": "Mostra Griglia",
    "snapGrid": "Aggancia alla Griglia",
    "gridSetting": "Impostazioni Griglia",
    "showGuides": "Mostra Guide",
    "snapGuides": "Aggancia alle Guide",
    "crossPoint0": "Nessuno",
    "crossPoint1": "Arco",
    "crossPoint2": "Intervallo",
    "crossPoint3": "Quadrato",
    "crossPoint4": "Due Lati",
    "crossPoint5": "Tre Lati",
    "showMargins": "Mostra Margini",
    "marginSetting": "Impostazioni Margini",
    "insText": "Inserisci Testo",
    "insHyper": "Inserisci Collegamento",
    "insAttach": "Inserisci allegato",
    "insNote": "Inserisci Nota",
    "insCom": "Inserisci Commento",
    "swimTitle": {
      "noShow": "Non mostrare",
      "showTop": "Mostra in alto",
      "showLeft": "Mostra a sinistra"
    },
    "keepFormat": "Mantieni la formattazione del sorgente",
    "matchFormat": "Abbina la formattazione della destinazione",
    "compare": "Confronto dei dati",
    "error": "Identificazione delle anomalie",
    "summarize": "Riepilogo",
    "trend": "Previsione tendenze",
    "org_analysis": "Analisi organizzazione",
    "check": "Diagnosi organizzazione",
    "ganttTotal": "Panoramica del progetto",
    "ganttProgress": "Stato del progetto",
    "ganttRisk": "Identificazione rischio",
    "ganttShare": "Analisi di fine progetto",
    "flowPart": "Rilevamento diagramma di flusso",
    "flowDesc": "Descrizione diagramma di flusso",
    "flowImprove": "Ottimizzazione diagramma di flusso",
    "more": "Altro"
  },
  "tw": {
    "bringFront": "置於頂層",
    "bringForward": "上移一層",
    "sendBack": "置於底層",
    "sendBackWard": "下移一層",
    "group": "組合",
    "unGroup": "取消組合",
    "left": "左對齊",
    "center": "水平居中",
    "right": "右對齊",
    "top": "頂端對齊",
    "middle": "垂直居中",
    "bottom": "底端對齊",
    "horizontal": "横向分佈",
    "vertical": "縱向分佈",
    "width": "等寬",
    "height": "等高",
    "width&height": "等大小",
    "angle": "等角度",
    "connector": "連接線",
    "text": "所有文本框",
    "shape": "形狀",
    "img": "圖片",
    "guideLine": "參考線",
    "showGrid": "顯示網格",
    "snapGrid": "吸附網格",
    "gridSetting": "網格設置",
    "showGuides": "顯示參考線",
    "snapGuides": "吸附參考線",
    "crossPoint0": "無",
    "crossPoint1": "弧線",
    "crossPoint2": "間隙",
    "crossPoint3": "正方形",
    "crossPoint4": "兩面",
    "crossPoint5": "三面",
    "showMargins": "顯示邊界",
    "marginSetting": "邊界設置",
    "insText": "插入文本",
    "insHyper": "插入超連結",
    "insAttach": "插入附件",
    "insNote": "插入注釋",
    "insCom": "插入評論",
    "swimTitle": {
      "noShow": "不顯示",
      "showTop": "顯示頂部",
      "showLeft": "顯示左側"
    },
    "keepFormat": "保留文本源格式",
    "matchFormat": "匹配文本當前格式",
    "compare": "資料比較",
    "error": "異常識別",
    "summarize": "摘要",
    "trend": "趨勢預測",
    "org_analysis": "組織分析",
    "check": "組織診斷",
    "ganttTotal": "專案概覽",
    "ganttProgress": "專案進度",
    "ganttRisk": "風險識別",
    "ganttShare": "專案經驗傳承",
    "flowPart": "流程圖偵測",
    "flowDesc": "流程圖說明",
    "flowImprove": "流程圖最佳化",
    "more": "更多"
  }
}
</i18n>
<template>
    <div class="expand-context" v-show="showExpand" ref="expandContext" :style="{ top: expandContextTop + 'px' }">
        <!-- 层级 二级菜单 -->
        <MenuList v-show="expandContextType == 'layer'" :menuList="layerMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 对齐 二级菜单 -->
        <MenuList v-show="expandContextType == 'align'" :menuList="alignMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 分布 二级菜单 -->
        <MenuList
            v-show="isMultisel && expandContextType == 'distribute'"
            :menuList="distributeMenuList"
            @handleClicks="handleClicks(...arguments)"
        />

        <!-- 等大小 二级菜单 -->
        <MenuList v-show="isMultisel && expandContextType == 'sameSize'" :menuList="sameSizeMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 粘贴 二级菜单 -->
        <div v-if="expandContextType == 'rememberFontStyle'">
            <div class="remember-box" @mouseenter="handleMouseenter('rememberFontStyle', $event)">
                <RadioGroup vertical v-model="customFontStyle" @on-change="rememberFontStyle">
                    <Radio label="0">
                        <span>
                            {{ $t("keepFormat") }}
                        </span>
                    </Radio>
                    <Radio label="1">
                        <span>{{ $t("matchFormat") }}</span>
                    </Radio>
                </RadioGroup>
            </div>
        </div>

        <!-- 按类型选中 二级菜单 -->
        <MenuList v-show="expandContextType == 'selectByType'" :menuList="selectTypeMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 按图层选中 二级菜单 -->
        <div v-if="expandContextType == 'selectByLayer'">
            <div
                class="menu-item"
                v-for="(item, index) in layers"
                :key="index"
                @click="selectByLayer(index)"
                @mouseenter="handleMouseenter('selectByLayer', $event)"
            >
                <span>{{ item.name }}</span>
            </div>
        </div>

        <!-- 网格 二级菜单 -->
        <MenuList v-show="expandContextType == 'grid'" :menuList="gridMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 参考线 二级菜单 -->
        <MenuList v-show="expandContextType == 'guide'" :menuList="guideMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 连接线交点样式 二级菜单 -->
        <MenuList v-show="expandContextType == 'lineJump'" :menuList="lineJumpMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 页面边距 二级菜单 -->
        <MenuList v-show="expandContextType == 'margins'" :menuList="marginsMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 组合 二级菜单（未在右键菜单中找到） -->
        <!-- <div v-if='expandContextType == "Group"'>
            <div class='menu-item' :class='{"disabled-menu-item":!group}' @click='toGroups'>{{$t('group')}}</div>
            <div class='menu-item' :class='{"disabled-menu-item":!unGroup}' @click='toUnGroup'>{{$t('unGroup')}}</div>
        </div> -->
        <MenuList
            v-show="
                expandContextType == 'Group' &&
                (!this.group || this.mmShapeMultiState || this.ganttShapeMultiState || this.tableShapeMultiState || this.containOrgShape)
            "
            :menuList="groupMenuList"
            @handleClicks="handleClicks(...arguments)"
        />

        <!-- 替换形状 二级菜单-->
        <div v-if="expandContextType == 'libraryExpand' && this.expandLibraryDataLen != 0" style="padding: 0">
            <ExpandLibrary :noborder="true" />
        </div>
        <!-- 添加到我的符号库？ 二级菜单-->
        <div v-if="expandContextType == 'addSymbolToLibs' && !this.isMap" style="max-height: 200px; overflow-y: auto">
            <div
                class="menu-item menu-limitW lib-context-menu"
                v-for="item in customLibList"
                :key="item.tbID"
                @click="selectToLibs(item)"
                @mouseenter="handleMouseenter('addSymbolToLibs', $event)"
            >
                {{ item.title }}
            </div>
        </div>
        <!-- 添加到我的符号库 二级菜单-->
        <div v-if="expandContextType == 'addSymbolFromPageToLibs'" style="max-height: 200px; overflow-y: auto">
            <div
                class="menu-item menu-limitW lib-context-menu"
                v-for="item in customLibList"
                :key="item.tbID"
                @click="selectFromPageToLib(item)"
                @mouseenter="handleMouseenter('addSymbolFromPageToLibs', $event)"
            >
                {{ item.title }}
            </div>
        </div>

        <!-- 插入 二级菜单-->
        <MenuList v-show="expandContextType == 'Insert' && !this.isMultiSel" :menuList="insertMenuList" @handleClicks="handleClicks(...arguments)" />

        <!-- 显示泳道图主标题 二级菜单-->
        <MenuList v-show="expandContextType == 'swimTitle'" :menuList="swimTitleMenuList" @handleClicks="handleClicks(...arguments)" />

        <template v-if="EDCONFIG.AI.ENABLE">
            <!-- AI 生成内容菜单，因使用 mixin 抽离为单独组件 -->
            <AiMenuList v-if="expandContextType == 'AI'" />

            <!-- AI 图片分析 -->
            <AIFloatMenuPictureAnalysis v-if="expandContextType == 'pictureAnalysis'" :showSubtitle="false" />

            <!-- AI 思维导图，选择多个子主题时 -->
            <AiMindmap2 v-if="expandContextType == 'aiMindmap2'" />

            <!-- AI 生成换风格 -->
            <AiImage v-show="expandContextType == 'aiImage'" />

            <!-- aiChart-->
            <AiChart v-if="expandContextType == 'aiChart' || expandContextType == 'aiTable'" :expandContextType="expandContextType" />

            <!-- ai orgshape-->
            <AiOrg v-if="expandContextType == 'aiOrgShape'" />

            <!-- aiGantt-->
            <AiGantt v-if="expandContextType == 'aiGantt'" />

            <!-- aiFlow-->
            <AiFlow v-if="expandContextType == 'aiFlowchart' || expandContextType == 'aiTextFlowchart'"></AiFlow>
        </template>

        <component :is="activedExpandContext"></component>
    </div>
</template>

<script lang="ts">
    declare var EDDocument: any;
    declare var eSnapFlags: any;
    declare var eToolType: any;
    declare var eOrderAct: any;
    import mvLayer from "./expandMenus/mvLayer.vue";
    import mvPage from "./expandMenus/mvPage.vue";
    import AiMenuList from "./expandMenus/AiMenuList.vue";
    import AiImage from "./expandMenus/AiImage.vue";
    import AiChart from "./expandMenus/AiChart.vue";
    import AiOrg from "./expandMenus/AiOrg.vue";
    import AiGantt from "./expandMenus/AiGantt.vue";
    import AiFlow from "./expandMenus/AiFlow.vue";
    import ExpandLibrary from "../../Modals/library/ExpandLibrary.vue";
    import MenuList from "@/app/components/MenuList.vue";
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import merge from "lodash/merge";
    import library from "@/app/store/modules/library";
    import { aiStatusType } from "@/app/components/ai3/enum";
    import { InternalLimitTableIds, OverseaLimitTableIds } from "@/app/utils/constant";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";
    import AiMindmap2 from "./expandMenus/AiMindmap2.vue";

    @Component({
        components: {
            mvLayer: () => import("./expandMenus/mvLayer.vue"),
            mvPage: () => import("./expandMenus/mvPage.vue"),
            AiMenuList,
            AiImage,
            ExpandLibrary,
            MenuList,
            AiChart,
            AiOrg,
            AiGantt,
            AiFlow,
            AIFloatMenuPictureAnalysis,
            AiMindmap2,
        },
    })
    export default class ExpandDrops extends Vue {
        expandContextType: string = "";
        expandContextTop: number = 0;
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        disableConnector = true; // 页面是否存在连接线
        disableShape = true; // 页面是否存在形状
        disableImg = true; // 页面是否存在图片
        disableGuideLine = true; //页面是否存在参考线
        disableText = true; //页面是否存在文本块
        activeShapeOrder: string = "";
        debounceInput = undefined;
        get layerMenuList() {
            return {
                list: [
                    {
                        key: "bringFront",
                        label: this.$t("bringFront"),
                        shortcut: "Ctrl+Shift+]",
                        disabled: this.activeShapeOrder == "top",
                    },
                    {
                        key: "sendBack",
                        label: this.$t("sendBack"),
                        shortcut: "Ctrl+Shift+[",
                        disabled: this.activeShapeOrder == "bottom",
                    },
                    {
                        key: "bringForward",
                        label: this.$t("bringForward"),
                        shortcut: "Ctrl+]",
                        disabled: this.activeShapeOrder == "top",
                    },
                    {
                        key: "sendBackWard",
                        label: this.$t("sendBackWard"),
                        shortcut: "Ctrl+[",
                        disabled: this.activeShapeOrder == "bottom",
                    },
                ],
            };
        }
        get alignMenuList() {
            return {
                list: [
                    { key: "left", label: this.$t("left"), shortcut: "Alt+L" },
                    { key: "center", label: this.$t("center"), shortcut: "Alt+C" },
                    { key: "right", label: this.$t("right"), shortcut: "Alt+R" },
                    { divide: true },
                    { key: "top", label: this.$t("top") },
                    { key: "middle", label: this.$t("middle") },
                    { key: "bottom", label: this.$t("bottom") },
                ],
            };
        }
        get distributeMenuList() {
            return {
                list: [
                    { key: "horizontal", label: this.$t("horizontal") },
                    { key: "vertical", label: this.$t("vertical") },
                ],
            };
        }
        get sameSizeMenuList() {
            return {
                list: [
                    { key: "width", label: this.$t("width") },
                    { key: "height", label: this.$t("height") },
                    { key: "angle", label: this.$t("angle") },
                    { key: "width&height", label: this.$t("width&height") },
                ],
            };
        }
        get selectTypeMenuList() {
            return {
                list: [
                    {
                        key: "connector",
                        label: this.$t("connector"),
                        disabled: this.disableConnector,
                    },
                    { key: "shape", label: this.$t("shape"), disabled: this.disableShape },
                    { key: "img", label: this.$t("img"), disabled: this.disableImg },
                    {
                        key: "guideLine",
                        label: this.$t("guideLine"),
                        disabled: this.disableGuideLine,
                    },
                    { key: "text", label: this.$t("text"), disabled: this.disableText },
                ],
            };
        }
        get gridMenuList() {
            return {
                list: [
                    {
                        key: "showGrid",
                        label: this.$t("showGrid"),
                        checked: this.isShowGrid,
                        showVip: !this.vip,
                    },
                    { key: "snapGrid", label: this.$t("snapGrid"), checked: this.isShowSnapGrid },
                    { key: "gridSetting", label: this.$t("gridSetting") },
                ],
            };
        }
        get guideMenuList() {
            return {
                list: [
                    {
                        key: "showGuides",
                        label: this.$t("showGuides"),
                        checked: this.isShowGuideline,
                    },
                    {
                        key: "snapGuides",
                        label: this.$t("snapGuides"),
                        checked: this.isShowSnapGuideline,
                    },
                ],
            };
        }
        get lineJumpMenuList() {
            return {
                list: [
                    {
                        key: "crossPoint0",
                        label: this.$t("crossPoint0"),
                        checked: this.activeJPStyle == -1,
                    },
                    {
                        key: "crossPoint1",
                        label: this.$t("crossPoint1"),
                        checked: this.activeJPStyle == 0,
                    },
                    {
                        key: "crossPoint2",
                        label: this.$t("crossPoint2"),
                        checked: this.activeJPStyle == 1,
                    },
                    {
                        key: "crossPoint3",
                        label: this.$t("crossPoint3"),
                        checked: this.activeJPStyle == 2,
                    },
                    {
                        key: "crossPoint4",
                        label: this.$t("crossPoint4"),
                        checked: this.activeJPStyle == 3,
                    },
                    {
                        key: "crossPoint5",
                        label: this.$t("crossPoint5"),
                        checked: this.activeJPStyle == 4,
                    },
                ],
            };
        }
        get marginsMenuList() {
            return {
                list: [
                    {
                        key: "showMargins",
                        label: this.$t("showMargins"),
                        checked: this.isShowMargin,
                    },
                    { key: "marginSetting", label: this.$t("marginSetting") },
                ],
            };
        }
        get groupMenuList() {
            return {
                list: [
                    { key: "group", label: this.$t("group"), disabled: !this.group },
                    { key: "unGroup", label: this.$t("unGroup"), disabled: !this.unGroup },
                ],
            };
        }
        get insertMenuList() {
            return {
                list: [
                    {
                        key: "insText",
                        label: this.$t("insText"),
                        shortcut: "",
                        disabled: !this.isConnectLine,
                    },
                    { key: "insNote", label: this.$t("insNote"), shortcut: "Ctrl+Alt+Z" },
                    { key: "insCom", label: this.$t("insCom"), shortcut: "Ctrl+Alt+X" },
                    { key: "insHyper", label: this.$t("insHyper"), shortcut: "Ctrl+K" },
                    { key: "insAttach", label: this.$t("insAttach"), shortcut: "Ctrl+H" },
                ],
            };
        }
        get swimTitleMenuList() {
            return {
                list: [
                    { key: "noShow", label: this.$t("swimTitle.noShow") },
                    { key: "showTop", label: this.$t("swimTitle.showTop") },
                    { key: "showLeft", label: this.$t("swimTitle.showLeft") },
                ],
            };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                // 层级 二级菜单点击事件
                [
                    "bringFront",
                    () => {
                        this.toFront();
                    },
                ],
                [
                    "sendBack",
                    () => {
                        this.toBack();
                    },
                ],
                [
                    "bringForward",
                    () => {
                        this.toForward();
                    },
                ],
                [
                    "sendBackWard",
                    () => {
                        this.toBackward();
                    },
                ],
                // 对齐 二级菜单点击事件
                [
                    "left",
                    () => {
                        this.alignShape("left");
                    },
                ],
                [
                    "center",
                    () => {
                        this.alignShape("center");
                    },
                ],
                [
                    "right",
                    () => {
                        this.alignShape("right");
                    },
                ],
                [
                    "top",
                    () => {
                        this.alignShape("top");
                    },
                ],
                [
                    "middle",
                    () => {
                        this.alignShape("middle");
                    },
                ],
                [
                    "bottom",
                    () => {
                        this.alignShape("bottom");
                    },
                ],
                // 分布 二级菜单点击事件
                [
                    "horizontal",
                    () => {
                        this.dis("hor");
                    },
                ],
                [
                    "vertical",
                    () => {
                        this.dis("ver");
                    },
                ],
                // 等大小 二级菜单点击事件
                [
                    "width",
                    () => {
                        this.sameSizes("w");
                    },
                ],
                [
                    "height",
                    () => {
                        this.sameSizes("h");
                    },
                ],
                [
                    "angle",
                    () => {
                        this.sameSizes("a");
                    },
                ],
                [
                    "width&height",
                    () => {
                        this.sameSizes("wh");
                    },
                ],
                // 按类型选中 二级菜单点击事件
                [
                    "connector",
                    () => {
                        this.selectByType("connector");
                    },
                ],
                [
                    "shape",
                    () => {
                        this.selectByType("shape");
                    },
                ],
                [
                    "img",
                    () => {
                        this.selectByType("img");
                    },
                ],
                [
                    "guideLine",
                    () => {
                        this.selectByType("guideline");
                    },
                ],
                [
                    "text",
                    () => {
                        this.selectByType("text");
                    },
                ],
                // 网格 二级菜单点击事件
                [
                    "showGrid",
                    () => {
                        this.toggleGrid();
                    },
                ],
                [
                    "snapGrid",
                    () => {
                        this.snapGrid();
                    },
                ],
                [
                    "gridSetting",
                    () => {
                        this.gridSetting();
                    },
                ],
                // 参考线 二级菜单点击事件
                [
                    "showGuides",
                    () => {
                        this.toggleGuide();
                    },
                ],
                [
                    "snapGuides",
                    () => {
                        this.snapGuides();
                    },
                ],
                // 连接线交点样式 二级菜单
                [
                    "crossPoint0",
                    () => {
                        this.lineJumpsChangeds(0);
                    },
                ],
                [
                    "crossPoint1",
                    () => {
                        this.lineJumpsChangeds(1);
                    },
                ],
                [
                    "crossPoint2",
                    () => {
                        this.lineJumpsChangeds(2);
                    },
                ],
                [
                    "crossPoint3",
                    () => {
                        this.lineJumpsChangeds(3);
                    },
                ],
                [
                    "crossPoint4",
                    () => {
                        this.lineJumpsChangeds(4);
                    },
                ],
                [
                    "crossPoint5",
                    () => {
                        this.lineJumpsChangeds(5);
                    },
                ],
                // 页面边距 二级菜单点击事件
                [
                    "showMargins",
                    () => {
                        this.showMargin();
                    },
                ],
                [
                    "marginSetting",
                    () => {
                        this.marginSetting();
                    },
                ],
                // 组合 二级菜单点击事件（未在右键菜单中找到）
                [
                    "group",
                    () => {
                        this.toGroups();
                    },
                ],
                [
                    "unGroup",
                    () => {
                        this.toUnGroup();
                    },
                ],
                // 插入 二级菜单点击事件
                [
                    "insText",
                    () => {
                        this.isConnectLine && this.insertTextOnLine();
                    },
                ],
                [
                    "insNote",
                    () => {
                        !this.isMultiSel && this.showNote();
                    },
                ],
                [
                    "insCom",
                    () => {
                        !this.isMultiSel && this.showComment();
                    },
                ],
                [
                    "insHyper",
                    () => {
                        !this.isMultiSel && this.showHyper();
                    },
                ],
                [
                    "insAttach",
                    () => {
                        !this.isMultiSel && this.showAttach();
                    },
                ],
                // 显示泳道图主标题 二级菜单点击事件
                [
                    "noShow",
                    () => {
                        this.showSwimTitle(0);
                    },
                ],
                [
                    "showTop",
                    () => {
                        this.showSwimTitle(1);
                    },
                ],
                [
                    "showLeft",
                    () => {
                        this.showSwimTitle(2);
                    },
                ],
                // ai相关
                [
                    "compare",
                    () => {
                        this.aiClickMenu(aiStatusType.graphCompare, this.$t(key));
                    },
                ],
                [
                    "error",
                    () => {
                        this.aiClickMenu(aiStatusType.graphAbnormal, this.$t(key));
                    },
                ],
                [
                    "summarize",
                    () => {
                        this.aiClickMenu(aiStatusType.graphSummary, this.$t(key));
                    },
                ],
                [
                    "trend",
                    () => {
                        this.aiClickMenu(aiStatusType.graphPredict, this.$t(key));
                    },
                ],
                [
                    "chartMore",
                    () => {
                        this.aiClickMenu(aiStatusType.graphChat, this.$t("more"), true);
                    },
                ],
                [
                    "org_analysis",
                    () => {
                        this.aiClickMenu(aiStatusType.orgAnalyse, this.$t(key));
                    },
                ],
                [
                    "check",
                    () => {
                        this.aiClickMenu(aiStatusType.orgDiagnosis, this.$t(key));
                    },
                ],
                [
                    "orgMore",
                    () => {
                        this.aiClickMenu(aiStatusType.orgChat, this.$t("more"), true);
                    },
                ],
                [
                    "ganttTotal",
                    () => {
                        this.aiClickMenu(aiStatusType.ganttSummarize, this.$t(key));
                    },
                ],
                [
                    "ganttProgress",
                    () => {
                        this.aiClickMenu(aiStatusType.ganttProgress, this.$t(key));
                    },
                ],
                [
                    "ganttRisk",
                    () => {
                        this.aiClickMenu(aiStatusType.ganttRisk, this.$t(key));
                    },
                ],
                [
                    "ganttShare",
                    () => {
                        this.aiClickMenu(aiStatusType.ganttExpirence, this.$t(key));
                    },
                ],
                [
                    "ganttMore",
                    () => {
                        this.aiClickMenu(aiStatusType.ganttChat, this.$t("more"), true);
                    },
                ],
                [
                    "flowPart",
                    () => {
                        this.aiClickMenu(aiStatusType.flowchartAnalyse, this.$t(key));
                    },
                ],
                [
                    "flowDesc",
                    () => {
                        this.aiClickMenu(aiStatusType.flowchartExplain, this.$t(key));
                    },
                ],
                [
                    "flowImprove",
                    () => {
                        this.aiClickMenu(aiStatusType.flowchartOptimize, this.$t(key));
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        aiClickMenu(id, ustr, onlyChangeStatus = false) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("aiAnalyse", id, ustr, onlyChangeStatus);
            });
            this.closeContext();
        }
        get showContextExpandTimer() {
            return this.$store.state.ui.showContextExpandTimer;
        }

        set showContextExpandTimer(newV) {
            this.$store.commit("setStatus", {
                type: "showContextExpandTimer",
                data: newV,
            });
        }

        debounce(func, delay = 1000, immediate = false) {
            const ts = this;
            return function (...args) {
                if (immediate && !ts.showContextExpandTimer) {
                    func.apply(ts, args);
                }
                ts.showContextExpandTimer && clearTimeout(ts.showContextExpandTimer);
                ts.showContextExpandTimer = setTimeout(() => {
                    func.apply(ts, args);
                }, delay);
            };
        }

        handle(Fun, flag, e) {
            this.$emit(Fun, flag, e);
        }

        handleMouseenter(flag, e) {
            this.debounceInput("handleMouseenter", flag, e);
        }

        closeContext() {
            this.$store.commit("closeContext");
        }
        toGroups() {
            let view = window["_view"];
            if (this.group) {
                view.group();
                this.closeContext();
            }
        }
        toUnGroup() {
            let view = window["_view"];
            if (this.unGroup) {
                view.unGroup();
                this.closeContext();
            }
        }
        toFront() {
            let view = window["_view"];
            view.orderShape(eOrderAct.BringFront);
            this.closeContext();
        }
        toForward() {
            let view = window["_view"];
            view.orderShape(eOrderAct.BringForward);
            this.closeContext();
        }
        toBack() {
            let view = window["_view"];
            view.orderShape(eOrderAct.SendBack);
            this.closeContext();
        }
        toBackward() {
            let view = window["_view"];
            view.orderShape(eOrderAct.SendBackward);
            this.closeContext();
        }
        alignShape(type: string) {
            let view = window["_view"];

            switch (type) {
                case "left":
                    view.alignShapes(0);
                    break;
                case "center":
                    view.alignShapes(1);
                    break;
                case "right":
                    view.alignShapes(2);
                    break;
                case "top":
                    view.alignShapes(3);
                    break;
                case "middle":
                    view.alignShapes(4);
                    break;
                case "bottom":
                    view.alignShapes(5);
                    break;
            }
            this.closeContext();
        }
        selectByType(type) {
            let view = window["_view"];
            switch (type) {
                case "connector":
                    view.selAllConnectors();
                    break;
                case "shape":
                    view.selectAllShapes();
                    break;
                case "img":
                    view.selectAllImages();
                    break;
                case "guideline":
                    view.selectAllGuideLines();
                    break;
                case "text":
                    view.selectAllTextBoxs();
            }
            this.closeContext();
        }
        rememberFontStyle(type: string) {
            let data = merge({}, this.$store.state.ui.customPreferContent || {}, {
                customFontStyle: type,
            });
            this.$store.dispatch("setUserContentPrefer", data);
        }
        get customFontStyle() {
            return this.$store.state.ui.customFontStyle;
        }
        set customFontStyle(newVal) {
            this.$store.commit("setStatus", {
                type: "customFontStyle",
                data: newVal,
            });
        }
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }

        get showGrid() {
            return this.$store.state.ui.showGrid;
        }

        set showGrid(v) {
            this.$store.commit("setStatus", {
                type: "showGrid",
                data: v,
            });
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        uploadTimer = 0;

        updateToCloud(obj, type?) {
            if (this.uploadTimer) {
                clearTimeout(this.uploadTimer);
            }
            this.uploadTimer = setTimeout(() => {
                let newShowGrid = obj.showGrid ? 1 : 0;
                this.showGrid = newShowGrid;
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    obj: { showGrid: newShowGrid },
                };
                if (this.userInfo)
                    this.$edApi.updateUserPrefer(params).then((e) => {
                        console.log(e);
                    });
            }, 500);
        }
        selectByLayer(index) {
            if (this.layers.length > 0) {
                index = this.layers.length - 1 - index;
            }
            window["_view"].selectLayerShapes(index);
            this.closeContext();
        }

        showSwimTitle(type) {
            let view = window["_view"];
            if (!view) return;
            view.setSpecial("showMainTitle", type);
            this.closeContext();
        }

        showHyper() {
            let view = window["_view"];
            if (view._activeShape && view._activeShape.toGantt()) {
                let gantt = view._activeShape.toGantt();
                let vecSels = [];
                gantt.getSelectedTasks(vecSels);
                if (vecSels.length != 0) {
                    let vecCols = gantt.getColumnArrayByType(13); //Hyperlink
                    if (vecCols.length != 0) {
                        gantt._taskIdColIdPair.first = vecSels[0]._id;
                        gantt._taskIdColIdPair.second = vecCols[0]._colId;
                    }
                }
            }

            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "hyperlink",
            });
            this.closeContext();
        }
        showAttach() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "attach",
            });
            this.closeContext();
        }
        showNote() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "note",
            });
            this.closeContext();
        }
        showComment() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "comment",
            });
            this.closeContext();
        }
        get vipStateFuncList() {
            return this.$store.getters.vipStateFuncList;
        }
        showFunVipTip() {
            let list = [];
            list = this.vipStateFuncList.slice();
            list.push("funcGrid");
            this.$bus.$emit("toggleFuncVipTip", { visible: true, vipFuncs: list, upgradeTrigger: "removeGrid" });
            this.closeContext();
        }
        insertTextOnLine() {
            // 连接线上添加文本
            this.closeContext();
            window["_view"].insertTextOnConnector();
        }
        dis(type: string) {
            let view = window["_view"];
            let t = type === "hor" ? 0 : 4;
            view.distributeShapes(t);
            this.closeContext();
        }
        sameSizes(type: string) {
            let view = window["_view"];
            let t = type === "w" ? 0 : type === "h" ? 1 : type === "a" ? 2 : 3;
            view.sameSize(t);
            this.closeContext();
        }
        toggleGrid() {
            let view = window["_view"];
            if (!view) return;

            let checked = !view._doc._config._showGrid;
            if (this.vip || (!this.vip && checked)) {
                view.showGridBox(checked);
                this.updateToCloud({ showGrid: checked });
            } else {
                if (!window.EDCONFIG.IS_SDK) {
                    view.showGridBox(false);
                }
                this.$store.commit("setStatus", {
                    type: "removeGrid",
                    data: false,
                });
                this.$store.commit("setStatus", {
                    type: "triggerType",
                    data: "removeGrid",
                });
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "removeGrid",
                });
                if (!this.internal && this.lang !== "zh") {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeTrigger",
                        data: "removeGrid",
                    });
                    this.$bus.$emit("togglePromodal", true, 2, 1);
                } else {
                    this.showFunVipTip();
                }
            }
            this.closeContext();
        }
        snapGrid() {
            // 对齐网格
            let view = window["_view"];
            if (!view) return;
            let checked = EDDocument._gcfg._snapFlags & eSnapFlags.RulerSubDiv && EDDocument._gcfg._snapFlags & eSnapFlags.Grid;
            view.snapToGridBox(!checked);
            this.closeContext();
        }
        gridSetting() {
            let ts: any = this;
            ts.$bus.$emit("changeRightViewActiveKey", "pageset");
            ts.$bus.$emit("changeRightView", "pageset", false, "other");
            this.closeContext();
        }
        toggleGuide() {
            let view = window["_view"];
            if (!view) return;

            let checked = !view._doc._config._showGuideline;
            view.showGuideLinesBox(checked);
            this.closeContext();
        }
        snapGuides() {
            let checked = !!(EDDocument._gcfg._snapFlags & eSnapFlags.GuideLine);
            window["_view"].snapToGuideLine(!checked);
            this.closeContext();
        }
        lineJumpsChangeds(index: number) {
            // window["_view"].lineJumpsChanged(index);
            // window["_view"].setPageStatus();

            this.$bus.$emit("changePageConnectLine", {
                type: "jumpStyle",
                data: index - 1,
            });
            if ((index != 0 && this.$store.state.page.jumpMode == 0) || (index == 0 && this.$store.state.page.jumpMode != 0)) {
                // 有跳点模式时不更新跳点模式，没有默认设置为水平
                this.$bus.$emit("changePageConnectLine", {
                    type: "jumpMode",
                    data: index == 0 ? 0 : 1,
                });
                window["_view"].lineJumpsModeChanged(index == 0 ? 0 : 1);
            }
            window["_view"].lineJumpsStyleChanged(index - 1);
            this.closeContext();
        }
        showMargin() {
            EDDocument._gcfg._showPageMargin = !EDDocument._gcfg._showPageMargin;
            if (EDDocument._gcfg._showPageMargin) {
                window["_view"]._activePage._margin.set(EDDocument._gcfg._pageMarginX, EDDocument._gcfg._pageMarginY);
            }
            window["_view"].drawBackground();
            this.$store.commit("setPageStat", {
                type: "showMargin",
                data: EDDocument._gcfg._showPageMargin,
            });
            this.closeContext();
        }
        marginSetting() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "Options",
            });
            this.closeContext();
        }
        get activeJPStyle() {
            if (this.$store.state.page.jumpMode) {
                return this.$store.state.page.jumpStyle;
            } else {
                return -1;
            }
        }
        get isMultisel() {
            return this.$store.state.shape.isMultiSel;
        }
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }
        get isConnectLine() {
            return this.$store.getters.isConnectLine;
        }

        get expandLibraryDataLen() {
            return this.$store.state.dialog.expandLibraryData && this.$store.state.dialog.expandLibraryData.length;
        }
        /*添加到我的符号库->我的收藏*/
        async selectFromPageToLib(item) {
            this.closeContext();
            if (this.isMultisel) {
                this.$bus.$emit("open-addSymbolsToLibs", {
                    tableID: item.tbID,
                    tableName: item.trueName,
                    dbName: this.extraDB[2],
                    isShowMessage: true,
                });
            } else {
                let view = window["_view"];
                let symbolData = view.saveSymbolToXml();
                let { data } = await view.saveSymbolToBlob();

                let dbObj = {
                    name: symbolData.name || "",
                    data: symbolData.data || "",
                    parent: item.trueName,
                    blob: data || "",
                };
                this.$bus.$emit("addSymbolToDB", {
                    dbName: this.extraDB[2],
                    tableName: item.trueName,
                    tableID: item.tbID,
                    dbObj,
                    isShowMessage: true,
                });
            }
        }

        get mutiSelect() {
            return this.$store.state.library.mutiSelect;
        }
        get contextLocker() {
            return this.$store.state.library.contextLocker;
        }
        set contextLocker(v) {
            this.$store.commit("setLibraryState", {
                type: "contextLocker",
                data: v,
            });
        }
        get limitTableIds() {
            return this.internal ? InternalLimitTableIds : OverseaLimitTableIds;
        }
        selectToLibs(item) {
            if (this.contextLocker) return;
            let view = window["_view"];
            this.closeContext();
            if (!this.vip && ~this.limitTableIds.indexOf(this.shape.tableID)) {
                this.$checkAuth({
                    type: "limitShapeSave",
                    buyTrigger: "addSymbolToMyLibraryNew",
                    libraryName: this.shape.name,
                });
                return;
            }
            this.contextLocker = true;
            if (item.tbID == this.$store.state.library.collectTBID) {
                this.sensors.track("saveAsMySymbol", {
                    Catalogues: "editFileProcess",
                });
            }
            let id = item.tbID;
            let userInfo = this.$store.state.user.userInfo,
                collectDB = this.extraDB[2],
                collectTB = item.trueName,
                collectTBID = id;

            let dbObj = {
                name: this.shape.name,
                [`${this.lang}_name`]: this.shape.langName,
                data: view.addFromLibId(this.shape.shape, this.shape.tableID),
                parent: collectTB,
                blob: this.shape.blob,
            };

            if (this.mutiSelect) {
                // 多选符号处理
                this.$bus.$emit("mutiAddShape", {
                    DBName: collectDB,
                    tableName: collectTB,
                    tableID: collectTBID,
                    isShowMessage: true,
                });
                return;
            }

            let updateData = {
                DBName: collectDB,
                tableName: collectTB,
                tableID: collectTBID,
                nowItem: -1,
                updateType: "addSymbol",
                dbObj: dbObj,
                versionDB: `myDBVersion_${userInfo.user_id}`,
            };
            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "update",
                urls: this.urls,
                data: updateData,
            });
            let ossList = this.$store.state.library.ossList;
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "updateOK") {
                    let ts: any = this;
                    let dbName = collectDB;
                    let tableID = collectTBID;
                    ts.$bus.$emit("setLibrary", {
                        type: "updateLibrary",
                        groupName: dbName,
                        tableID: tableID,
                    });
                    ts.$store.commit("setLibraryDisplayList", {
                        // 清空预览缓存
                        groupName: collectDB,
                        tableName: collectTB,
                        data: [],
                    });
                    ts.$bus.$asyncEmit("uploadToCloud", { message, isShowMessage: true }).then((e: any) => {
                        let version = e.data.version;
                        this.worker.postMessage({
                            type: "setVersion",
                            urls: this.urls,
                            data: {
                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                tableID: tableID,
                                version,
                                params: {
                                    updateModified: true,
                                },
                            },
                        });
                    });
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
            };
        }

        get isShowMargin() {
            return this.$store.state.page.showMargin;
        }
        get activedExpandContext() {
            if (this.expandContextType === "mvLayer" || this.expandContextType === "mvPage") {
                return this.expandContextType;
            }
            return "";
        }
        get showExpand() {
            return this.$store.state.ui.showContextExpand;
        }
        set showExpand(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showContextExpand",
                data: v,
            });
        }
        get showContext() {
            //右键菜单显示/隐藏
            return this.$store.state.ui.showContextMenu;
        }
        @Watch("showContext")
        changeLayerOpertaion(val) {
            if (val) {
                // 重新获取activeShape的层级关系
                this.activeShapeOrder = window["_view"].getShapeOrder();
            }
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get group() {
            return this.$store.state.shape.group;
        }
        get unGroup() {
            return this.$store.state.shape.unGroup;
        }
        get layers() {
            return this.$store.state.page.activedPageLayers;
        }
        get isShowGrid() {
            return this.$store.state.page.showGrid;
        }
        get isShowGuideline() {
            return this.$store.state.page.showGuideline;
        }
        get isShowSnapGrid() {
            return this.$store.state.page.showSnapGrid;
        }
        get isShowSnapGuideline() {
            return this.$store.state.page.showSnapGuideline;
        }
        get customLibList() {
            let list = this.$store.state.library.menuList[0];
            let arr =
                list?.children.map((v, k) => {
                    return {
                        title: v[`tableName_${this.lang}`] || v.tableName,
                        trueName: v.tableName,
                        tbID: v.id,
                    };
                }) || [];
            return arr;
        }
        get mmShapeMultiState() {
            return this.$store.state.shape.isAllMMShape;
        }
        get ganttShapeMultiState() {
            return this.$store.state.shape.isAllGanttShape;
        }
        get tableShapeMultiState() {
            return this.$store.state.shape.isAllTableShape;
        }
        get containOrgShape() {
            return this.$store.state.shape.containOrgShape;
        }
        get isMap() {
            return this.$store.state.shape.type == "EDChart" && this.$store.state.echart.chartType == "map";
        }
        get extraDB() {
            return this.$store.state.library.extraDB;
        }
        get shape() {
            return this.$store.state.ui.selectLibraryShape;
        }

        // @Watch('showExpand')
        // onExpandChanged(val: boolean) {
        //     if(!val){
        //         // this.expandContextType = '';
        //     }
        // }
        // 菜单显示隐藏重新计算位置
        changeExpandPosition() {
            let ele: HTMLElement = <HTMLElement>this.$refs.expandContext;
            let parentEle = ele.parentElement; // mainContext dom.
            let previousEle = ele.previousElementSibling;
            let view = window["_view"];
            // console.log('expandchange')
            const padding = 7;
            ele.style.left = previousEle.clientWidth + padding * 2 + "px";
            this.$nextTick(() => {
                //当超出屏幕边界的时候，调整位置
                if (ele.offsetLeft + ele.offsetWidth + parentEle.offsetLeft > window.innerWidth) {
                    console.log("-left", ele.offsetLeft + ele.offsetWidth + parentEle.offsetLeft);
                    ele.style.left = -ele.offsetWidth + "px";
                }
                if (ele.offsetTop + ele.offsetHeight + parentEle.offsetTop > window.innerHeight) {
                    console.log("-top", ele.offsetTop + ele.offsetHeight + parentEle.offsetTop);
                    ele.style.top = this.expandContextTop - ele.offsetHeight + 26 + "px"; // 26 refer to css class menu-item height.
                }
                // 如果菜单选项又多->少重新计算位置
                if (ele.offsetHeight + ele.offsetTop < this.expandContextTop + 26) {
                    ele.style.top = this.expandContextTop + "px";
                }
            });
            this.disableConnector = view._activePage.hasConnector();
            this.disableShape = view._activePage.hasShape();
            this.disableImg = view._activePage.hasImg();
            this.disableGuideLine = view._activePage.hasGuideLine();
            this.disableText = view._activePage.hasTextBlock();
        }
        mounted() {
            this.debounceInput = this.debounce(this.handle, 300, false);
        }
        created() {
            let ts: any = this;
            ts.$bus.$on("changeContextType", (type: string, top: number) => {
                this.expandContextTop = top;
                this.expandContextType = type;
            });
            ts.$bus.$on("changeExpandPosition", this.changeExpandPosition);
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("changeContextType");
            ts.$bus.$off("changeExpandPosition");
        }
    }
</script>
